// extracted by mini-css-extract-plugin
export default {"AirlineIcon__image":"AirlineIcon_AirlineIcon__image__ODZiN"};